/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRectangleFilled = createReactComponent("filled", "rectangle-filled", "IconRectangleFilled", [["path", { "d": "M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z", "key": "svg-0" }]]);

export { IconRectangleFilled as default };
//# sourceMappingURL=IconRectangleFilled.mjs.map
